import React from 'react'
import { useTranslation } from 'react-i18next'
/* COMPONENTS */
import BPIcon from '../BPIcon'

const PrintCell = ({ data, onClick }) => {
  const { t } = useTranslation()
  return (
    <BPIcon
      icon='print'
      className='bp3-grid-icon-print'
      tooltip={t('print')}
      onClick={() => onClick(data)}
    />
  )
}

export default PrintCell
